import { IconComponentProps } from './index'

const Restore = ({ width = 24, height = 24, color = 'currentColor', customClass = '' }: IconComponentProps) => <svg className={customClass} width={width} height={height} viewBox='0 0 24 24'>
  <g clip-path='url(#clip0_10754_168896)'>
    <path d='M19 4.01367H15.5L14.5 3.01367H9.5L8.5 4.01367H5V6.01367H19V4.01367ZM6 7.01367V19.0137C6 20.1137 6.9 21.0137 8 21.0137H16C17.1 21.0137 18 20.1137 18 19.0137V7.01367H6ZM14 14.0137V18.0137H10V14.0137H8L12 10.0137L16 14.0137H14Z' fill={color} />
  </g>
  <defs>
    <clipPath id='clip0_10754_168896'>
      <rect width='24' height='24' fill='none' transform='translate(0 0.0136719)'/>
    </clipPath>
  </defs>
</svg>

export default Restore
